import React from 'react';
import "./FavouriteTable.scss";
import CommonTable from "../../../../components/common/CommonTable/CommonTable.jsx";
import { StarIcon } from "../../../../assets/Svg/SvgImages.jsx";
import { useDispatch, useSelector } from 'react-redux';
import { setFavPairList, setPairName } from '../../../../features/persist/persistSlice';
import { toastMsg } from '../../../../components/common/Toast/Toast';
import { MESSAGES } from '../../../../constants/constants';
import { parseJSON, toFix } from '../../../../helpers/commonHelper';
import { setLastPrice, setPairList, setSelectedPair } from '../../../../features/ats/atsSlice';
import { useSearchParams } from 'react-router-dom';
const FavouriteTable = ({
  pairList,
  onSetRemoveFav
}) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const favPairList = useSelector(state => state?.persist?.favPairList);
  const selectedPair = useSelector(state => state?.ats?.selectedPair);
  const fields = ['Watchlist', 'Price', 'Change'];
  const addRemoveFavPair = (pair, itemIndex) => {
    const pairs = parseJSON(pairList);
    const favouriteList = [...favPairList];
    const index = favouriteList.findIndex(o => o.pair_key.toLowerCase() === pair.pair_key.toLowerCase());
    if (index < 0) {
      pair.isFav = true;
      favouriteList.push(Object.assign({}, pair));
      pairs[itemIndex].isFav = true;
      dispatch(setPairList(pairs));
      toastMsg.success(MESSAGES.PAIR_ADDED_TO_FAVOURITE);
    } else {
      favouriteList.splice(index, 1);
      pairs[itemIndex].isFav = false;
      dispatch(setPairList(pairs));
      toastMsg.success(MESSAGES.PAIR_REMOVED_TO_FAVOURITE);
    }
    dispatch(setFavPairList(favouriteList));
  };
  const onPairChange = item => {
    if (selectedPair?.pair_key.toLowerCase() === item.pair_key.toLowerCase()) return;
    setSearchParams({
      ['symbol']: item.pair_key.toLowerCase()
    });
    // setSearchParams({ ['symbol']: item?.name?.replace('/', '_').toLowerCase() })
    dispatch(setPairName(item.pair_key));
    dispatch(setSelectedPair(parseJSON(item)));
    dispatch(setLastPrice(item.last_price));
  };
  return <>
            <div className='favouriteTable'>
                <CommonTable fields={fields} sortbuttons={true} doubleicon={true}>
                    {pairList?.map((item, index) => {
          const changePercent = Number(item.priceChangePercent ?? item.change ?? 0);
          const isNegative = changePercent < 0;
          return <tr key={index} className='pair_row' onClick={() => onPairChange(item)}>
                            <td className='text-start'>
                                <div className='d-flex align-items-center'>
                                    <button className={`starIcon ${item.isFav ? 'active' : ''}`} onClick={() => addRemoveFavPair(parseJSON(item), index)} type='button'><StarIcon /></button>
                                    {`${item.otherCurrency || ''}/${item.baseCurrency || ''}`}
                                    {/* {`${item?.name.toUpperCase() || ''}`} */}
                                </div>
                            </td>
                            <td>{item.last_price}</td>
                            <td>
                                <div className={isNegative ? 'red_text' : 'green_text'}>
                                    {`${isNegative ? '' : '+'}${toFix(changePercent, 2)}%`}
                                </div>
                            </td>
                        </tr>;
        })}
                </CommonTable>
            </div>
        </>;
};
export default FavouriteTable;